import {AiGeneratedArticlePayload} from "../../features/articles/models/interfaces/ai-generated-article.interface";

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const buildLexicalJson = (content: string): string => JSON.stringify({
    root: {
        children: [
            {
                type: "paragraph",
                format: "",
                indent: 0,
                direction: "ltr",
                version: 1,
                children: [
                    {
                        type: "text",
                        text: content,
                        detail: 0,
                        format: 0,
                        mode: "normal",
                        style: "",
                        version: 1
                    }
                ]
            }
        ],
        direction: "ltr",
        format: "",
        indent: 0,
        type: "root",
        version: 1
    }
});

const multilineLexicalJson = (paragraphs: string[]): string => JSON.stringify({
    root: {
        children: paragraphs.map(text => ({
            type: "paragraph",
            format: "",
            indent: 0,
            direction: "ltr",
            version: 1,
            children: [
                {
                    type: "text",
                    text,
                    detail: 0,
                    format: 0,
                    mode: "normal",
                    style: "",
                    version: 1
                }
            ]
        })),
        direction: "ltr",
        format: "",
        indent: 0,
        type: "root",
        version: 1
    }
});

const baseContent = [
    "AI przygotowała streszczenie dokumentu oraz jego pełną treść.",
    "Tekst jest podzielony na sekcje, aby pacjent mógł łatwo znaleźć potrzebne informacje.",
    "Wystarczy zaakceptować nową wersję lub ją edytować."
];

const improvedContent = [
    "AI zoptymalizowała aktualny artykuł, upraszczając język i dodając brakujące konteksty.",
    "Sekcje zostały wyrównane i zawierają dodatkowe wskazówki dla pacjenta.",
    "Po zaakceptowaniu treść zastąpi aktualną wersję formularza."
];

export const mockAiNewArticlePayload: AiGeneratedArticlePayload = {
    title: buildLexicalJson("Nowy artykuł przygotowany przez AI"),
    abstract: buildLexicalJson("Krótki opis nowego artykułu wygenerowanego z dokumentu."),
    content: multilineLexicalJson(baseContent),
    tags: ["ortopedia", "kolano", "rehabilitacja"],
};

export const mockAiImprovedArticlePayload: AiGeneratedArticlePayload = {
    title: buildLexicalJson("Ulepszona wersja istniejącego artykułu"),
    abstract: buildLexicalJson("AI wzmocniła główne punkty artykułu i uprościła streszczenie."),
    content: multilineLexicalJson(improvedContent),
    tags: ["ortopedia", "kolano", "artroskopia"],
};

export const getMockAiNewArticle = async (_fileName?: string): Promise<AiGeneratedArticlePayload> => {
    await delay(1300);
    return mockAiNewArticlePayload;
};

export const getMockAiImprovedArticle = async (_articleId?: string): Promise<AiGeneratedArticlePayload> => {
    await delay(1100);
    return mockAiImprovedArticlePayload;
};

